import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JobsService } from 'src/app/core/services/jobs.service';
import { AuthenticationService } from '../../../../../core/services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationService } from '../../../../../core/services/application.service'; // Add this import
import { JobTypes } from '../../../../../core/models/globals';

@Component({
  selector: 'app-job-partition-dialog',
  templateUrl: './job-partition-dialog.component.html',
  styleUrls: ['./job-partition-dialog.component.scss']
})
export class JobPartitionDialogComponent implements OnInit {

  partitions: string[] = [];
  jobForm: UntypedFormGroup;
  currentLoggedInUser = this.authenticationService.currentUserValue.username;
  depName: string = this.data.depName;
  appName: string = this.data.appName;
  appVersion: string = this.data.appVersion;

  constructor(
    public dialog: MatDialogRef<JobPartitionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
        depName: string;
        partition: string;
      jobName: string;
      appName: string,
      appVersion: string,
      actionText: string;
      actionValue: any;
    },
    public jobService: JobsService,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private _spinner: NgxSpinnerService,
    private applicationService: ApplicationService // Add this service
  ) { }

  ngOnInit() {
    this.jobForm = new UntypedFormGroup({
      job_Partition: new UntypedFormControl('', Validators.required),
    });
    this.loadPartitions();
  }

  loadPartitions() {

    this._spinner.show("jobPartition");

    if (!this.applicationService) {
      this._spinner.hide("jobPartition");
      this._snackBar.open('Service initialization error', 'OK', {
        duration: 3000,
      });
      return;
    }
    // extract first partition from comma-separated string
    const getFirstPartition = (partitionString: string): string => {
      if (!partitionString) return '';
      return partitionString.split(',')[0].trim();
    };

    if (!this.appVersion || this.appVersion.trim() === '') {
      // Call getNodeGroups when appVersion is not available
      this.applicationService.getNodeGroups(this.depName, this.appName)
        .subscribe({
          next: (data: string[]) => {
            console.log('getNodeGroups API Response:', data);
            this._spinner.hide("jobPartition");

            if (data && Array.isArray(data) && data.length > 0) {
              this.partitions = data.filter(nodeGroup => nodeGroup && nodeGroup.trim() !== '');

              if (this.partitions.length > 0) {
                const selectedPartition = getFirstPartition(this.data.partition) || this.partitions[0];
                this.jobForm.controls['job_Partition'].setValue(selectedPartition);
              }
            } else {
              this._snackBar.open('No partitions found', 'OK', {
                duration: 3000,
              });
            }
          },
          error: (err) => {
            console.error('getNodeGroups API Error:', err);
            this._spinner.hide("jobPartition");
            this._snackBar.open('Error loading partitions', 'OK', {
              duration: 3000,
            });
          }
        });
    } else {
      this.applicationService.getApplicationStaticCores(
        this.depName,
        this.appName,
        this.appVersion,
        this.currentLoggedInUser
      ).subscribe({
        next: (data: any) => {
          console.log('getApplicationStaticCores API Response:', data);
          this._spinner.hide("jobPartition");

          if (data && data.appNodeGroup) {
            this.partitions = data.appNodeGroup
              .split(',')
              .map((nodeGroup: string) => nodeGroup.trim())
              .filter((nodeGroup: string) => nodeGroup !== '');

            if (this.partitions.length > 0) {
              const jobPartition = getFirstPartition(this.data.partition);
              const defaultPartition = getFirstPartition(data.defaultNodeGroups) || this.partitions[0];
              const selectedPartition = jobPartition || defaultPartition;
              this.jobForm.controls['job_Partition'].setValue(selectedPartition);
            }
          } else {
            this._snackBar.open('No partitions found', 'OK', {
              duration: 3000,
            });
          }
        },
        error: (err) => {
          console.error('getApplicationStaticCores API Error:', err);
          this._spinner.hide("jobPartition");
          this._snackBar.open('Error loading partitions', 'OK', {
            duration: 3000,
          });
        }
      });
    }
  }

  onCancel() {
    this.dialog.close();
  }

  onSubmit(form) {
    this._spinner.show("jobPartition");
    if (this.jobForm.value.job_Partition !== null) {
      try {
        let newPartition = this.jobForm.value.job_Partition;
        this.jobService.triggerAnActionForJob(
          this.data.depName,
          this.data.jobName,
          this.data.actionText,
          this.data.actionValue,
          "false",
          "",
          "",
          "",
          newPartition
        ).subscribe(() => {
          this._spinner.hide("jobPartition");
          this._snackBar.open('Job partition updated successfully', 'OK', {
            duration: 3000,
          });
          this.dialog.close(true);
        });
      } catch (e) {
        this._spinner.hide("jobPartition");
        this._snackBar.open('Error in updating job partition', 'OK', {
          duration: 3000,
        });
        this.dialog.close(false);
      }
    } else {
      form.controls.job_Partition.touched = true;
      this._spinner.hide("jobPartition");
    }
  }
}
